<script>
	import { page } from "$app/stores";
	import { watchObject, tryEval } from "cando-util";

	import { store } from "$lib/utilities/store";
	import {
		action,
		clearRecordSelection,
	} from "$lib/sections/Admin/Management/tableFunctions.js";
	import { formUpdate } from "$lib/sections/Admin/formUpdate";

	import ScreenSize from "$lib/components/ScreenSize.svelte";
	import Table from "$lib/sections/Admin/Table.svelte";
	import RecordDetail from "$lib/sections/Admin/Management/RecordDetail.svelte";
	import SettingsFormInput from "$lib/sections/Admin/SettingsFormInput.svelte";

	const col = "userCases";

	let screenWidth;
	let breakpoint;

	$: leftMargin = screenWidth > 1440 ? (screenWidth - 1440) / 2 : 0;

	$: url = $page.url;
	$: currentDocId = url.searchParams.get("docId");
	$: lang = window.location.pathname.includes(`/${$page.data.lang}/`)
		? $page.data.lang
		: "";

	$: record = $store?.[col]?.docs?.[currentDocId] || {};
	$: watchObject(record, "record");
	$: watchObject($store, "store");
	const getCaseDoc = (docId, col = "userCases") =>
		$store?.[col]?.docs?.[docId] || null;
	$: watchObject(getCaseDoc, "getCaseDoc");
	const getSubmissionDoc = (docId, col = "userSubmissions") =>
		$store?.[col]?.docs?.[docId] || null;
	$: watchObject(getSubmissionDoc, "getSubmissionDoc");

	$: tfFunction =
		$store?.settings?.docs?.["App Settings"]?.tfUserCases?.value || `[]`;
	$: tableFields = tryEval(tfFunction);

	$: dbFunction =
		$store?.settings?.docs?.["App Settings"]?.dbUserCases?.value ||
		`(() => console.log('no dash board function'))()`;
	$: dashboard = tryEval(dbFunction);

	let loading = true;
	let updateTimeout;

	const settingUpdate = async (event) => {
		if (updateTimeout) {
			clearTimeout(updateTimeout);
		}

		updateTimeout = setTimeout(async () => {
			await formUpdate(
				event,
				$store,
				loading,
				"settings",
				"App Settings",
				"",
			);
		}, 1000);
	};
</script>

<ScreenSize bind:width={screenWidth} bind:breakpoint showBreakpoint={false} />

<div
	class="max-w-[1440px] px-2 sm:px-4"
	style={`margin-left: ${leftMargin}px;`}
>
	<div class="w-full">
		<section class="mt-6 space-y-4">
			{#if !!currentDocId}
				<RecordDetail
					{col}
					docId={currentDocId}
					onClose={clearRecordSelection}
					{tableFields}
					allowFormEdit={!!$store?.userRoles?.admin}
				/>
			{:else}
				{#if typeof dashboard === "function"}
					{@html dashboard()}
				{/if}
				<Table
					{col}
					includeAll={true}
					{action}
					{tableFields}
					adjustLeftMargin={false}
					allowEdit={false}
					allowTableColumnEdit={!!$store?.userRoles?.admin}
				/>
			{/if}
			{#if $store?.userRoles?.admin}
				<div><hr /></div>
				{#if $store?.settings?.docs?.["App Settings"]?.dbUserCases}
					<div class="shadow-xl collapse collapse-arrow bg-base-300">
						<input type="checkbox" />
						<div class="font-medium collapse-title">
							Dashboard Function
						</div>
						<div class="collapse-content">
							<SettingsFormInput
								col={"settings"}
								settingId={"App Settings"}
								fld={{
									key: "dbUserCases",
									...$store?.settings?.docs?.["App Settings"]
										?.dbUserCases,
								}}
								{lang}
								handleChange={settingUpdate}
							/>
						</div>
					</div>
				{:else}
					<div>
						No dashboard function found in App Settings
						(dbUserCases)
					</div>
				{/if}
				<div><hr /></div>
				{#if $store?.settings?.docs?.["App Settings"]?.tfUserCases}
					<div class="shadow-xl collapse collapse-arrow bg-base-300">
						<input type="checkbox" />
						<div class="font-medium collapse-title">
							Table Fields Function
						</div>
						<div class="collapse-content">
							<SettingsFormInput
								col={"settings"}
								settingId={"App Settings"}
								fld={{
									key: "tfUserCases",
									...$store?.settings?.docs?.["App Settings"]
										?.tfUserCases,
								}}
								{lang}
								handleChange={settingUpdate}
							/>
						</div>
					</div>
				{:else}
					<div>
						No tableFields function found in App Settings
						(tfUserCases)
					</div>
				{/if}
				<div><hr /></div>
			{/if}
		</section>
	</div>
</div>
